// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleCard_container__bkZd6","checks":"SingleCard_checks__RrBSU"};